module.exports = __webpack_public_path__ + "assets/img/btn-view-e9e2dc26.png";